import { render, staticRenderFns } from "./center.vue?vue&type=template&id=5279a8f8&scoped=true&"
import script from "./center.vue?vue&type=script&lang=js&"
export * from "./center.vue?vue&type=script&lang=js&"
import style0 from "./center.vue?vue&type=style&index=0&id=5279a8f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5279a8f8",
  null
  
)

export default component.exports